
import { Vue, Component } from 'vue-property-decorator';
// import ip6 from '@/assets/ip6.svg';

@Component
export default class previewModal extends Vue {
  visible = false;
  confirmLoading = false;
  ModalText = 'Content of the modal';

  content: any = '';

  init(val: any) {
    console.log(val);
    this.content = val;
    this.visible = true;
  }

  handleOk(e: MouseEvent) {
    console.log(e);
    this.confirmLoading = true;
    setTimeout(() => {
      this.visible = false;
      this.confirmLoading = false;
    }, 2000);
  }
  handleCancel(e: MouseEvent) {
    console.log(e);
    this.visible = false;
  }

  throwTags(id: any, list: any) {
    return list.filter((item: any) => item.id === id)[0] || '';
  }
}
